<template>
  <div>
    <el-card>
      <el-table :data="list" v-loading="loading" border style="width: 100%">
        <el-table-column prop="name" label="会员名称"></el-table-column>
        <el-table-column prop="tabNames" label="健康标签"></el-table-column>
        <el-table-column prop="age" label="年龄"></el-table-column>
        <el-table-column prop="idNumber" label="身份证号"></el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="formattercreateTime"
          width="200"
        ></el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="details(scope.row.id)">健康问卷</el-button>
            <el-button type="primary" size="small" @click="programme(scope.row.id)">健康方案</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { Message } from "element-ui";
import axiosUtil from "../../utils/AxiosUtils.js";
export default {
  data() {
    return {
      memberInfo: "",
      list: [],
      loading: false,
      value: "",
      page: {
        pageNum: 1,
        pageSize: 1000,
        total: 0,
      },
      tabTypeId:''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    formattercreateTime(row) {
      return this.getDate(row.createTime);
    },
    details(id){
      this.$router.push({ path: "questionnaireAnswer",query: { id: id}});
    },
    programme(id){
      this.$router.push({ path: "programmeList",query: { id: id}});
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getMedicineList();
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm))
        .toLocaleString()
        .replace(/年|月/g, "-")
        .replace(/日/g, "        ");
      return tt;
    },
    init() {
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.sanbo.health.doc.manager.member.list",
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          pageNum:_this.page.pageNum,
          pageSize:_this.page.pageSize
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.list=obj.userHealthMemberVoList;
            _this.page.total=obj.amout;
          } else {
            Message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
  },
};
</script>
<style scoped>
</style>